import { capitalize, map } from 'lodash';

import { usePatientPageNavigate } from '@/Pages/SinglePatientDetails/PatientPageNavigation';

import { ReactComponent as QuestionnaireIcon } from '../../../../assets/icons/questionnaireIcon.svg';
import useQuestionnairesService from '../../../../services/questionnairesService';
import type { IPatientQuestionnaire } from '../../../../services/questionnairesService/types';
import { patientTabsUrl } from '../../../SinglePatientDetails/types';

export default function useGeneralQuestionnaireEvent(patientUuid: string) {
  const { generalQuestionnaires } = useQuestionnairesService(patientUuid);

  const { navigateToPatientPage } = usePatientPageNavigate();

  return map(generalQuestionnaires, ({ name, createdAt }: IPatientQuestionnaire) => {
    return {
      name: capitalize(name.toLowerCase()),
      date: createdAt,
      icon: QuestionnaireIcon,
      ctaText: 'View General Questionnaires',
      cta() {
        navigateToPatientPage(`/patients/${patientUuid}/${patientTabsUrl.activityLog}`);
      },
    };
  });
}
